import {isArray} from "lodash-es";
import {Tooltip} from "antd";
import React from "react";

export const config = {
  rowSelection: false,
  columns: [
    {
      title: 'SPU_ID',
      dataIndex: 'productId',
      width: 200,
      ellipsis: true
    },
    {
      title: 'SPU名称',
      dataIndex: 'prodName',
      width: 220,
      ellipsis: true
    },
    {
      title: '数量',
      dataIndex: 'size',
      width: 120,
      ellipsis: true
    },
    {
      title: '是否可查看',
      dataIndex: 'allowView',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '是否必选',
      dataIndex: 'required',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '是否参与计算',
      dataIndex: 'allowCalculation',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '是否发包',
      dataIndex: 'allowSendPack',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      name: 'startDate',
      width: 200,
      itemType: 'date',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      name: 'endDate',
      width: 200,
      itemType: 'date',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: 'SKU包含类型',
      dataIndex: 'selectTypeName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '单位',
      key: ['unitInfo', 'unitName'],
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SPU适用门店',
      dataIndex: 'applyProductShopList',
      width: 220,
      render: (_, record: Record<string, any>)=>{
        const shopList = isArray(record?.applyProductShopList)?record?.applyProductShopList:[];
        const txt = shopList?.map(item => item.companyName).join(',');
        return <Tooltip title={txt||""}  placement="topLeft">
          <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',width:210}}>{txt||""}</div>
        </Tooltip>
      },
    },
    {
      title: 'SPU状态',
      dataIndex: 'spuEnabled',
      width: 100,
      fixed: 'right',
      render: 'enableRender',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 100,
      fixed: 'right',
      render: 'actionRender'
    },
  ],
  search: [
    {
      name: 'productId',
      label: 'SPU_ID',
    },
    {
      name: 'prodNameKeyword',
      label: 'SPU名称',
    },
  ],
}

